import { render } from "./FoundProd.vue?vue&type=template&id=358886c4&scoped=true"
import script from "./FoundProd.vue?vue&type=script&lang=js"
export * from "./FoundProd.vue?vue&type=script&lang=js"

import "./FoundProd.vue?vue&type=style&index=0&id=358886c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358886c4"]])

export default __exports__